export default [
  {
    target: '#main-title',
    content:
      'Welcome to the PSES Topics page. Here you can see average scores for each of the six topics.',
    params: { enableScrolling: true },
    offset: -400,
  },
  {
    target: '#main-content-side',
    content:
      'In the area below you can view charts, tables, and maps of topic scores. Most objects show scores for all topics. If a respondent group is not specified, the topic score represents an average of all applicable groups.',
    params: { enableScrolling: true },
    offset: -400,
  },
  {
    target: '#topics-map',
    content:
      'The map, on the other hand, displays the average scores for a selected topic (defaulting to School Climate).',
    params: { enableScrolling: true },
    offset: -200,
  },
  {
    target: '#main-topic-filter-panel',
    content:
      'To select a new topic (for the map), select from the list of topics in the "Select a topic" panel. Additionally, you can also select a specific respondent group by opening the "Topic Filters".',
    params: { enableScrolling: true },
    offset: -200,
  },
  {
    target: '#main-topic-filter-panel',
    content:
      'If you select a specific topic, you will be provided with the option of selecting a subtopic. For example, if you select "School Climate," you may then select "Bullying" as a subtopic.',
    params: { enableScrolling: false },
  },
  {
    target: '#main-tour-button',
    content: 'Press here to take this tour again.',
    params: { enableScrolling: true },
    offset: -400,
  },
]
